import React, { useMemo } from 'react';

import { Box, Button, makeStyles } from '@material-ui/core';
import { Close } from '@mui/icons-material';

import SearchInput from '../../components/common/SearchInput';
import { quizCollectionPrivacyList } from '../../models/QuizCollection';

const useStyle = makeStyles((theme) => {
  return {
    closeIcon: {
      '&:hover': {
        color: '#333',
        cursor: 'pointer',
      },
      color: '#aaa',
      display: 'none !important',
      padding: 2,
      position: 'absolute',
      right: 20,
      top: 4,
    },
    filtersContainer: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
    },
    header: {
      marginRight: '4px',
    },
    headerContainer: {
      alignItems: 'center',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    },
    headerContainerLeft: {
      alignItems: 'center',
      display: 'flex',
      flexWrap: 'wrap',
      maxWidth: '500px',
      width: '100%',
    },
    headerContainerRight: {
      alignItems: 'end',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'flex-end',
      maxWidth: '500px',
    },
    inputContainer: {
      '& .NativeDatepicker, .NativeDatepicker .MuiBox-root, & select': {
        height: 30,
        width: 140,
      },
      '&:hover>.MuiSvgIcon-fontSizeSmall': {
        display: 'block !important',
      },
      position: 'relative',
    },
    searchInputRoot: {
      '& .MuiInput-input': {
        height: 30,
        padding: '0 5px',
      },
      '& .MuiInput-root': {
        height: 30,
      },
      height: 30,
    },
    select: {
      '& .MuiInputBase-input': {
        color: '#999',
        fontFamily: 'Roboto',
        fontSize: 13,
        height: '30px',
        padding: '0 5px',
      },
      '&:focus': {
        borderColor: theme.palette.primary.main,
        color: '#444',
        outline: 'none',
      },
      '&:hover': {
        borderColor: theme.palette.primary.main,
        color: '#444',
        cursor: 'pointer',
      },
      border: '1px solid #C8C8C8',
      borderRadius: '8px',
      color: '#999',
      height: '30px',
      overflow: 'hidden',
      width: '127px',
    },
    selectListWithBorder: {
      border: '1px solid #CCC',
      borderRadius: '8px',
    },
  };
});

const QuizListHeader = ({ selectedPrivacy, selectedTags, handleChangePrivacy, handleChangeSearch, handleChangeTag, handleSearch, search, tags, onClear }) => {
  const classes = useStyle();

  const privacyFilterList = useMemo(() => {
    return quizCollectionPrivacyList.map((privacy) => (
      <option key={privacy.value} value={privacy.value}>
        {privacy.label}
      </option>
    ));
  }, []);

  const isFilterActive = useMemo(() => {
    return selectedPrivacy || selectedTags.length > 0 || search;
  }, [selectedPrivacy, selectedTags, search]);

  return (
    <Box width="100%">
      <Box width="100%" display="flex" flexDirection="column" gridGap={14}>
        <Box className={classes.inputContainer} width="100%" display="flex" flexWrap="wrap" gridGap={10} alignItems="center">
          <Box width="300px">
            <SearchInput
              onSearch={handleSearch}
              onKeywordUpdate={handleChangeSearch}
              placeholder="Search quizzes..."
              disableSearch
              searchValue={search}
              classes={{
                root: classes.searchInputRoot,
              }}
            />
          </Box>

          <div className={classes.inputContainer}>
            <select className={classes.select} id="privacySelect" value={selectedPrivacy} onChange={(e) => handleChangePrivacy(e.target.value)}>
              <option value="">Privacy</option>
              {privacyFilterList}
            </select>
            {!!selectedPrivacy && <Close fontSize="small" className={classes.closeIcon} title="Reset Value" onClick={() => handleChangePrivacy('')} />}
          </div>

          <div className={classes.inputContainer}>
            <select
              className={classes.select}
              id="tagsSelect"
              value={selectedTags.length > 0 ? selectedTags[0] : ''}
              onChange={(e) => handleChangeTag(e.target.value ? [e.target.value] : [])}>
              <option value="">Tags</option>
              {tags.map((tag) => (
                <option key={tag} value={tag}>
                  {tag}
                </option>
              ))}
            </select>
            {selectedTags.length > 0 && <Close fontSize="small" className={classes.closeIcon} title="Reset Value" onClick={() => handleChangeTag([])} />}
          </div>

          <Box display="flex" gridGap={10}>
            <Button color="primary" variant="contained" style={{ height: 30, width: 124 }} onClick={handleSearch}>
              Search
            </Button>

            {isFilterActive && (
              <Button variant="outlined" style={{ height: 30, width: 80 }} onClick={onClear}>
                Clear
              </Button>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default QuizListHeader;
